<script>
import SideDrawer from "../package/sideDrawer.vue";
import TopImageSection from "../package/topImageSection.vue";
import SearchSection from "../package/searchSection.vue";
import BuyOffPlanSection from "../package/buyOffPlanSection.vue";
import FooterSection from "../package/footerSection.vue";
import DrawerAside from "../package/DrawerAside.vue";
import agentSignInSection from "../package/agentSignInSection.vue";
import propertyIconSet from "../package/propertyIconSet.vue";
import discoverMore from "../package/discoverMore.vue";
import SocialSection from "../package/socialSection.vue";
import AdvertisementThree from "../package/advertisementThree.vue";
import AgentsRegistration from "../package/agentsRegistration.vue";
import AdvertisementTwo from "../package/advertisementTwo.vue";
import AdvertisementOne from "../package/advertisementOne.vue";
import ContactUs from "../package/contactUs.vue";
import ConnectingProperties from "../package/connectingProperties.vue";
import StayUpToDate from "../package/stayUpToDate.vue";
import FindOutMore from "../package/findOutMore.vue";
import HeaderSection from "../package/HeaderSection.vue";
import { mapActions } from "vuex";
import NewPropertiesSection from "../package/newPropertiesSection.vue";
import EmailUsSectionLight from "../contact/emailUsSectionLight.vue";
// import MobileAppDownload from "../package/mobileAppDownload.vue";
import BlogWidgetView from "../blog/blogWidgetView/blogWidgetLayout.vue";

export default {
  name: "MainLayout",
  data() {
    return {
      adPage: "Home Page Creative Ads",
      adSuburbs: "",
      adsData: "",
      drawer: false,
      unfold: false,
      visible: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  components: {
    BlogWidgetView,
    NewPropertiesSection,
    HeaderSection,
    FindOutMore,
    StayUpToDate,
    ConnectingProperties,
    ContactUs,
    AdvertisementOne,
    AdvertisementTwo,
    AgentsRegistration,
    AdvertisementThree,
    SocialSection,
    DrawerAside,
    FooterSection,
    BuyOffPlanSection,
    SearchSection,
    TopImageSection,
    SideDrawer,
    discoverMore,
    propertyIconSet,
    agentSignInSection,
    EmailUsSectionLight,
    // MobileAppDownload
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Home";
  },
  methods: {
    ...mapActions("home", ["getAds"]),
    spread() {
      this.unfold = true;
      console.log("this.unfold = true");
    },
    fold() {
      this.unfold = false;
      console.log("this.unfold = false");
    },
    getAdsbyPageAndSuburb() {
      let body_params = {
        adPage: this.adPage,
        adSuburbs: this.adSuburbs
      };
      this.getAds({
        params: { other: body_params },
        callback: this.callbackAd
      });
    },
    callbackAd(resp) {
      if (resp.data.code == 0) {
        this.adsData = resp.data.data;
      } else {
      }
      console.log("this.adsData", this.adsData);
    }
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
    this.getAdsbyPageAndSuburb();
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <top-image-section />
<!--        <buy-off-plan-section />-->
        <!--      Moved to Main banner section [search-properties]-->
        <!--        <search-section/>-->
<!--        <new-properties-section />-->
        <property-icon-set />
<!--        <mobile-app-download />-->
        <advertisement-one
          :props-click="this.adsData.homePageCreativeAds1Click"
          :props-image="this.adsData.homePageCreativeAds1"
        />
        <!--        <advertisement-two-->
        <!--          :props-click="this.adsData.homePageCreativeAds2Click"-->
        <!--          :props-image="this.adsData.homePageCreativeAds2"-->
        <!--        />-->
        <!--        <find-out-more />-->
<!--        <contact-us />-->
        <email-us-section-light />
        <!-- <stay-up-to-date/> -->
        <connecting-properties />
        <!-- <advertisement-three/> -->
        <!-- <agents-registration/> -->
        <!-- <social-section/> -->
        <!-- <discover-more/> -->
        <blog-widget-view></blog-widget-view>
        <agent-sign-in-section />

      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #2d2d2d;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
  //color: #2D2D2D;
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}
</style>



// WEBPACK FOOTER //
// src/components/home/mainLayout.vue